import Vue from 'vue'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../layouts/error.vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../assets/styles/common.css'

import '../assets/styles/customer.scss'

import '../assets/styles/fullpage.css'

import '../assets/styles/flex.css'

import _69fcfb16 from '../layouts/aiChat.vue'
import _12af52ac from '../layouts/aiChatNew.vue'
import _77180f1e from '../layouts/blank.vue'
import _4bef94e1 from '../layouts/college.vue'
import _6c3372ed from '../layouts/cz.vue'
import _6f6c098b from '../layouts/default.vue'
import _74a226d4 from '../layouts/gongxu.vue'
import _1537b56f from '../layouts/headless.vue'
import _0a8624d0 from '../layouts/measurementLayout.vue'
import _1aa30dcf from '../layouts/onlyHeader.vue'
import _ef16083c from '../layouts/screen.vue'
import _f3aafe5e from '../layouts/screens.vue'
import _590707bc from '../layouts/serviceHallLayout.vue'
import _65ff5c6f from '../layouts/tcLayout.vue'
import _5929eebb from '../layouts/techActivity.vue'
import _d0094386 from '../layouts/xianlin.vue'
import _3df271cb from '../layouts/yangzhou.vue'

const layouts = { "_aiChat": sanitizeComponent(_69fcfb16),"_aiChatNew": sanitizeComponent(_12af52ac),"_blank": sanitizeComponent(_77180f1e),"_college": sanitizeComponent(_4bef94e1),"_cz": sanitizeComponent(_6c3372ed),"_default": sanitizeComponent(_6f6c098b),"_gongxu": sanitizeComponent(_74a226d4),"_headless": sanitizeComponent(_1537b56f),"_measurementLayout": sanitizeComponent(_0a8624d0),"_onlyHeader": sanitizeComponent(_1aa30dcf),"_screen": sanitizeComponent(_ef16083c),"_screens": sanitizeComponent(_f3aafe5e),"_serviceHallLayout": sanitizeComponent(_590707bc),"_tcLayout": sanitizeComponent(_65ff5c6f),"_techActivity": sanitizeComponent(_5929eebb),"_xianlin": sanitizeComponent(_d0094386),"_yangzhou": sanitizeComponent(_3df271cb) }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map((page) => {
        const p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$fetch) {
          p.push(page.$fetch())
        } else {
          // Get all component instance to call $fetch
          for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
            p.push(component.$fetch())
          }
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    },
  },

  components: {
    NuxtLoading
  }
}
